import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as models from '../models'

import { getLocalStorageKey } from './save-to-local-storage'

export const loadFromLocalStorage = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.load.request.observe().pipe(
      rxjsUtils.latestFrom(requestAction => ({
        context: meFeature.contexts.selectors.appContext.asObservable,
        orgChartId: rxjs.of(requestAction.data.orgChartId),
        requestAction: rxjs.of(requestAction),
      })),
      rxjs.map(({ context, orgChartId, requestAction }) => {
        if (!context) {
          return feature.actions.load.cancellation.from(requestAction).create({
            reason: `Cannot save ${orgChartId} org chart since the current context is unknown`,
            request: requestAction.data,
          })
        }
        const key = getLocalStorageKey(context, orgChartId)
        const orgChartJson = window.localStorage.getItem(key)
        if (orgChartJson) {
          const data = models.Data.fromJson(orgChartJson)
          return feature.actions.load.success.from(requestAction).create({
            request: requestAction.data,
            response: data,
          })
        }
        return feature.actions.load.cancellation.from(requestAction).create({
          reason: `No saved data found for ${orgChartId} org chart`,
          request: requestAction.data,
        })
      }),
    ),
)
